import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from "reactstrap";
import { getAdminProfile, globalSearch, logoutAdmin } from "../../api/ApiServices";
import { Image_Url, Local_Image_Url } from "../../api/ApiClient";
import Avatar from "../../components/Common/Avatar";
import avatar from "assets/img/brand/avatar-2.jpg";

const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_PATH || Image_Url;
const LOCAL_IMAGE_BASE_URL = process.env.REACT_APP_LOCAL_IMAGE_PATH || Local_Image_Url;

const AdminNavbar = (props) => {
  const { brandText, toggleSidebar } = props;
  const navigate = useNavigate();
  const [admin, setAdmin] = useState({ name: "Admin", image: "team-4-800x800.jpg" });

  const [searchQuery, setSearchQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchResults, setSearchResults] = useState([]);

  const staticPages = [
    { name: "Rooms & Chats", path: "/admin/rooms-chats", icon: "ni ni-chat-round text-white", iconBg: "bg-gradient-info" },
    { name: "Txns", path: "/admin/wallet-payments", icon: "ni ni-credit-card text-white", iconBg: "bg-gradient-warning" },
  ];

  useEffect(() => {
    if (!searchQuery || searchQuery.length < 2) {
      setSearchResults([]);
      return;
    }

    const delayDebounceFn = setTimeout(async () => {
      try {
        const data = await globalSearch(searchQuery);
        if (data && data.payload) {
          setSearchResults([
            ...(data.payload.users || []),
            ...(data.payload.rooms || []),
            ...(data.payload.txns || [])
          ]);
        }
      } catch (error) {
        console.error("Search failed", error);
      }
    }, 400);

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery]);

  const matchedUsers = searchResults.map(u => {
    let avatarUrl = `${LOCAL_IMAGE_BASE_URL}avatar-1.jpg`;

    if (u.type === "room") {
      return {
        name: u.title,
        caption: u.subtitle,
        path: `/admin/rooms-chats?highlight=${u.id}&searchText=${encodeURIComponent(u.title)}`,
        avatar: null,
        icon: "ni ni-chat-round text-white",
        iconBg: "bg-gradient-success",
        type: "room"
      };
    }

    if (u.type === "transaction") {
      return {
        name: u.title,
        caption: u.subtitle,
        path: `/admin/wallet-payments?highlight=${u.id}&searchText=${encodeURIComponent(u.title)}`,
        avatar: null,
        icon: "ni ni-credit-card text-white",
        iconBg: "bg-gradient-warning",
        type: "transaction"
      };
    }

    if (u.image && u.image !== "default.jpg" && u.image !== "no-user.png") {
      if (u.image.startsWith("http")) {
        avatarUrl = u.image;
      } else if (u.image.startsWith("avatar-")) {
        avatarUrl = `${LOCAL_IMAGE_BASE_URL}${u.image}`;
      } else {
        avatarUrl = `${IMAGE_BASE_URL}${u.image}`;
      }
    }

    return {
      name: u.title,
      caption: u.subtitle,
      path: `/admin/users-list?highlight=${u.id}&searchText=${encodeURIComponent(u.subtitle || u.title)}`,
      avatar: avatarUrl,
      icon: "ni ni-single-02 text-primary",
      type: "user"
    };
  });

  const filteredStaticPages = staticPages.filter(page =>
    page.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (page.name === "Rooms & Chats" && "rooms".includes(searchQuery.toLowerCase())) ||
    (page.name === "Txns" && "transactions".includes(searchQuery.toLowerCase()))
  ).map(page => ({ ...page, type: "page" }));

  // Group search results
  const usersList = matchedUsers.filter(u => u.type === "user");
  const roomsList = matchedUsers.filter(u => u.type === "room");
  const txnsList = matchedUsers.filter(u => u.type === "transaction");
  const pagesList = filteredStaticPages;

  const handleSearchNavigate = (path) => {
    setSearchQuery("");
    setShowDropdown(false);
    navigate(path);
  };
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getAdminProfile();
        console.log(data, "---------------hiii")
        const payload = data.payload;
        setAdmin({
          name: payload.name || "Admin",
          image: payload.image,
        });
      } catch (error) {
        console.error("Failed to load admin profile", error);
      }
    };

    fetchProfile();

    // Listen for image updates from Profile page
    const handleImageUpdate = (event) => {
      setAdmin((prev) => ({
        ...prev,
        image: event.detail,
      }));
    };

    window.addEventListener("adminProfileImageUpdated", handleImageUpdate);
    return () => {
      window.removeEventListener("adminProfileImageUpdated", handleImageUpdate);
    };
  }, []);

  const handleLogout = async () => {
    try {
      await logoutAdmin();
    } catch (error) {
      console.error("Backend logout failed", error);
    }
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("adminPermissions");
    navigate("/auth/login", { replace: true });
  };

  return (
    <Navbar className="navbar-dark sticky-top nav-bg" expand="md" id="navbar-main" style={{ zIndex: 1050 }}>
      <div  className="adminBoxx" >
        {/* Sidebar Toggle Button (Desktop) */}
        <div className="navbar-toggle-container d-none d-md-block mr-3">
          <div
            className="sidebar-toggle-btn-top"
            onClick={props.toggleSidebar}
            style={{ cursor: "pointer", color: "white", fontSize: "1.5rem" }}
          >
            <i className="ni ni-align-left-2" />
          </div>
        </div>

        <Link
          className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-flex align-items-center"
          to="/"
          style={{ minWidth: 'max-content', letterSpacing: '0.05em' }}
        >
          {brandText}
        </Link>

        {localStorage.getItem("userRole")?.toLowerCase() !== "judge" && (
          <Form className="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto" onSubmit={(e) => e.preventDefault()}>
            <FormGroup className="mb-0 position-relative" style={{ width: "320px", zIndex: 9999 }}>
              <InputGroup className="input-group-alternative border border-white" style={{ flexWrap: "nowrap" }}>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fas fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Search (Users / Rooms / Txns)"
                  type="text"
                  value={searchQuery}
                  className="custom-search-input"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setShowDropdown(true);
                  }}
                  onFocus={() => setShowDropdown(true)}
                  onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                />
              </InputGroup>

              {showDropdown && searchQuery && (usersList.length > 0 || roomsList.length > 0 || txnsList.length > 0 || pagesList.length > 0) && (
                <div
                  className="position-absolute bg-white rounded shadow-lg w-100 search-dropdown-container"
                  style={{ top: "calc(100% + 10px)", zIndex: 9999, overflow: "hidden" }}
                >
                  {/* CSS to fix native scrollbar destroying border-radius */}
                  <style dangerouslySetInnerHTML={{
                    __html: `
                  .search-dropdown-scroll::-webkit-scrollbar { width: 6px; }
                  .search-dropdown-scroll::-webkit-scrollbar-track { background: transparent; }
                  .search-dropdown-scroll::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
                  .search-dropdown-scroll::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
                `}} />

                  <div className="search-dropdown-scroll py-2" style={{ maxHeight: "350px", overflowY: "auto" }}>

                    {/* Category: Users */}
                    {usersList.length > 0 && (
                      <>
                        <div className="px-3 py-1 bg-secondary text-xs font-weight-bold text-muted text-uppercase mb-1">Users</div>
                        {usersList.map((item, idx) => (
                          <div
                            key={`user-${idx}`}
                            onClick={() => handleSearchNavigate(item.path)}
                            style={{ padding: "10px 15px", cursor: "pointer", transition: "all 0.2s ease" }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f6f9fc"}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                            className="d-flex align-items-center"
                          >
                            <Avatar src={item.avatar} name={item.name} size="sm" className="mr-3" />
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <span className="text-dark font-weight-600 d-block text-sm text-truncate" style={{ lineHeight: "1.2" }}>{item.name}</span>
                              {item.caption && <span className="text-muted d-block text-xs text-truncate" style={{ marginTop: "2px" }}>{item.caption}</span>}
                            </div>
                          </div>
                        ))}
                      </>
                    )}

                    {/* Category: Rooms */}
                    {roomsList.length > 0 && (
                      <>
                        {usersList.length > 0 && <hr className="my-2 border-light" />}
                        <div className="px-3 py-1 bg-secondary text-xs font-weight-bold text-muted text-uppercase mb-1">Rooms & Groups</div>
                        {roomsList.map((item, idx) => (
                          <div
                            key={`room-${idx}`}
                            onClick={() => handleSearchNavigate(item.path)}
                            style={{ padding: "10px 15px", cursor: "pointer", transition: "all 0.2s ease" }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f6f9fc"}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                            className="d-flex align-items-center"
                          >
                            <div className={`d-flex align-items-center justify-content-center mr-3 rounded-circle shadow-sm ${item.iconBg || 'bg-gradient-success'}`} style={{ width: "36px", height: "36px", minWidth: "36px" }}>
                              <i className={item.icon || "ni ni-chat-round text-white"} style={{ fontSize: "1rem" }} />
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <span className="text-dark font-weight-600 d-block text-sm text-truncate" style={{ lineHeight: "1.2" }}>{item.name}</span>
                              {item.caption && <span className="text-muted d-block text-xs text-truncate" style={{ marginTop: "2px" }}>{item.caption}</span>}
                            </div>
                          </div>
                        ))}
                      </>
                    )}

                    {/* Category: Transactions */}
                    {txnsList.length > 0 && (
                      <>
                        {(usersList.length > 0 || roomsList.length > 0) && <hr className="my-2 border-light" />}
                        <div className="px-3 py-1 bg-secondary text-xs font-weight-bold text-muted text-uppercase mb-1">Transactions</div>
                        {txnsList.map((item, idx) => (
                          <div
                            key={`txn-${idx}`}
                            onClick={() => handleSearchNavigate(item.path)}
                            style={{ padding: "10px 15px", cursor: "pointer", transition: "all 0.2s ease" }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f6f9fc"}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                            className="d-flex align-items-center"
                          >
                            <div className={`d-flex align-items-center justify-content-center mr-3 rounded-circle shadow-sm ${item.iconBg || 'bg-gradient-warning'}`} style={{ width: "36px", height: "36px", minWidth: "36px" }}>
                              <i className={item.icon || "ni ni-credit-card text-white"} style={{ fontSize: "1rem" }} />
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <span className="text-dark font-weight-600 d-block text-sm text-truncate" style={{ lineHeight: "1.2" }}>{item.name}</span>
                              {item.caption && <span className="text-muted d-block text-xs text-truncate" style={{ marginTop: "2px" }}>{item.caption}</span>}
                            </div>
                          </div>
                        ))}
                      </>
                    )}

                    {/* Category: Pages */}
                    {pagesList.length > 0 && (
                      <>
                        {(usersList.length > 0 || roomsList.length > 0 || txnsList.length > 0) && <hr className="my-2 border-light" />}
                        <div className="px-3 py-1 bg-secondary text-xs font-weight-bold text-muted text-uppercase mb-1">System Pages</div>
                        {pagesList.map((item, idx) => (
                          <div
                            key={`page-${idx}`}
                            onClick={() => handleSearchNavigate(item.path)}
                            style={{ padding: "10px 15px", cursor: "pointer", transition: "all 0.2s ease" }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f6f9fc"}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                            className="d-flex align-items-center"
                          >
                            <div className={`d-flex align-items-center justify-content-center mr-3 rounded-circle shadow-sm ${item.iconBg || 'bg-gradient-secondary'}`} style={{ width: "36px", height: "36px", minWidth: "36px" }}>
                              <i className={item.icon} style={{ fontSize: "1rem" }} />
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <span className="text-dark font-weight-600 d-block text-sm text-truncate" style={{ lineHeight: "1.2" }}>{item.name}</span>
                            </div>
                          </div>
                        ))}
                      </>
                    )}

                  </div>
                </div>
              )}
            </FormGroup>
          </Form>
        )}

        <Nav className="align-items-center d-none d-md-flex" navbar>
          <UncontrolledDropdown nav>
            <DropdownToggle className="pr-0" nav>
              <Media className="align-items-center">
                <span className="avatar avatar-sm rounded-circle">
                  <Avatar
                    src={admin.image}
                    name={admin.name}
                    size="sm"
                  />
                </span>
                <Media className="ml-2 d-none d-lg-block">
                  <span className="mb-0 text-sm font-weight-bold">
                    {admin.name}
                  </span>
                </Media>
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem className="noti-title" header tag="div">
                <h6 className="text-overflow m-0">Welcome!</h6>
              </DropdownItem>
              <DropdownItem to="/admin/profile" tag={Link}>
                <i className="ni ni-single-02" />
                <span>My profile</span>
              </DropdownItem>
              <DropdownItem onClick={handleLogout}>
                <i className="ni ni-user-run" />
                <span>Logout</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
      </div>
    </Navbar>
  );
};

export default AdminNavbar;
